import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as stringReistration from "../stringFiles/registration.json";
import { Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { BrandService } from '../brand/brand.service';

@Component({
  selector: 'app-slider',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.css'
})
export class SliderComponent implements OnInit {
  strings: any;
  slideIndex: any = 0;
  autoOn: any = true;
  brand = this.brandService.brand;
  constructor(private translate: TranslateService, private brandService: BrandService) {
    this.strings = stringReistration;
  }
  ngOnInit(): void {
    this.showSlides()
  }

  showSlides() {
    let slides = document.getElementsByClassName("mySlides") as HTMLCollectionOf<HTMLElement>;
    let dots = document.getElementsByClassName("dot") as HTMLCollectionOf<HTMLElement>;

    for (let i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
      dots[i].className = dots[i].className.replace(" active", "");
    }
    this.slideIndex++;
    if (this.slideIndex > slides.length) {
      this.slideIndex = 1;
    }
    slides[this.slideIndex - 1].style.display = "block";
    dots[this.slideIndex - 1].className += " active";
    if (this.autoOn) {
      setTimeout(() => this.showSlides(), 5000);
    }
  }
}